import {gql} from "@apollo/client";
import {REWARD_ENTITY} from "../entities/customRewardEntity";

export const REWARDS_QUERY = gql`
    ${REWARD_ENTITY}
    query rewards {
      rewards {...RewardEntity}
    }
`;